import styled from 'styled-components'

export const LinkOffBox = styled.div`
  display: inline-flex;
  transform: rotate(90deg);
  opacity: ${props => (props.disabled ? 0.2 : 1)};
  margin-right: 10px;
`
